import { Injectable, ErrorHandler } from '@angular/core';
import { SnackbarService } from '../_services/snackbar.service';
import { LoaderService } from '../_components/loader/loader.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(
    private snackBar: SnackbarService,
    private loader: LoaderService
  ) { }

  handleError(error: any) {
    console.log(error);
    if (error?.message?.includes("<show error>")) {
      let errormessage = error?.message?.split("<show error>");
      this.snackBar.openErrorSnackBar(
        errormessage?.length > 1 ? errormessage[1] : 'Sorry, some error occurred!',
        'manual',
      );
    }
    this.loader.showLoader(false);
    this.loader.showItemLoader(false);
    return error;
  }
}
